
import { Routes } from '@angular/router';

import { InicioComponent } from './inicio/inicio.component';

import { RegistroComponent } from './autenticacion/registro/registro.component';
import { InisesComponent } from './autenticacion/inises/inises.component';
import { RecuperarcontComponent } from './autenticacion/recuperarcont/recuperarcont.component';
// import { EditarComponent } from './items/editar/editar.component';


import { PerfilComponent } from './perfil/perfil.component';
import { PublicarComponent } from './publicaciones/publicar/publicar.component';
import { PublicacionesComponent } from './publicaciones/publicaciones/publicaciones.component';
// import { PublicacionComponent } from './publicacion/publicacion.component';
// import { NoteListComponent } from './notes/note-list/note-list.component';
// import { NoteDetailComponent } from './notes/note-detail/note-detail.component';
import { MispublicacionesComponent } from './publicaciones/mispublicaciones/mispublicaciones.component';
// import { SearchUiComponent } from './search-ui/search-ui.component';
// import { BusquedaComponent } from './busqueda/busqueda.component';
import { FileuploadComponent } from './fileupload/fileupload.component';

import { EncuestasComponent } from './modulos/encuestas/encuestas.component';
import { EncuestaComponent } from './modulos/encuesta/encuesta.component';
import { RepositorioComponent } from './modulos/repositorio/repositorio.component';
import { EquipoComponent } from './modulos/equipo/equipo.component';
import { SistemaComponent } from './modulos/sistema/sistema.component';
import { EventosComponent } from './modulos/eventos/eventos.component';
import  {ContactoComponent } from './modulos/contacto/contacto.component';
import { NoticiasComponent } from './modulos/noticias/noticias.component';
import { NoticiaComponent } from './modulos/noticia/noticia.component';

import { AuthGuard } from './core/auth.guard';
import { LoginGuard } from './core/login.guard';
import { BajadaComponent } from './modulos/bajada/bajada.component';
import { EventoComponent } from './modulos/evento/evento.component';


// sections name
const trabajadores = 'Trabajadores';
const posts = 'Posts';
const ingreso = 'Ingreso';
const secciones = 'Secciones';


export const ROUTES: Routes = [
  // home route
  // { path: '', component: BusquedaComponent },
  // { path: 'editar/:id', component: EditarComponent },  
  { path: '', component: NoticiasComponent },
  // { path: '', component: PublicacionesComponent },
  { path: 'encuestas', component: EncuestasComponent },
  { path: 'encuesta/:id', component: EncuestaComponent },
  { path: 'repositorio', component: RepositorioComponent },
  { path: 'equipo', component: EquipoComponent },
  { path: 'sistema', component: SistemaComponent },
  { path: 'eventos', component: EventosComponent },
  { path: 'contacto', component: ContactoComponent },
  { path: 'noticias', component: NoticiasComponent },
  { path: 'noticia/:id', component: NoticiaComponent },
  { path: 'evento/:id', component: EventoComponent },
  { path: 'bajada/:id', component: BajadaComponent },
  { path: 'subir', component: FileuploadComponent },


  // components routes - Autenticacion
  // { path: 'registro', component: RegistroComponent, data: {  active: false, icon: 'person_add', text: 'Crear Cuenta', section: ingreso }, canActivate: [LoginGuard] },
  { path: 'registro', component: RegistroComponent, data: {  active: false, icon: 'person_add', text: 'Crear Cuenta', section: ingreso }, canActivate: [LoginGuard] },
  { path: 'iniciosesion', component: InisesComponent, data: {  active: false, icon: 'person', text: 'Iniciar Sesión', section: ingreso }, canActivate: [LoginGuard] },
  { path: 'recuperarcont', component: RecuperarcontComponent, data: {  active: false, icon: 'lock', text: 'Reestablecer Contraseña', section: ingreso }, canActivate: [LoginGuard] },
  
  //Secciones
  { path: 'perfil', component: PerfilComponent, data: {  active: false, icon: 'person', text: 'Perfil', section: secciones },  canActivate: [AuthGuard] },
  { path: 'publicaciones', component: PublicacionesComponent, data: {  active: false, icon: 'person', text: 'Perfil', section: secciones } },
  { path: 'publicar', component: PublicarComponent, data: {  active: false, icon: 'mode_edit', text: 'Publicar', section: secciones }, canActivate: [AuthGuard] },
  // { path: 'publicar', component: PublicarComponent, data: {  active: false, icon: 'mode_edit', text: 'Publicar', section: secciones }, canActivate: [AuthGuard,PerfilGuard] },
  // { path: 'mispublicaciones/:id', component: MispublicacionesComponent, data: {  active: false, icon: 'list', text: 'Publicaciones', section: secciones },  canActivate: [AuthGuard] },

  { path: '**', redirectTo: '' },
];



// WEBPACK FOOTER //
// ./src/app/app.routing.ts